<template>
    <div>
        <v-date-picker
                v-if="this.times"
                mode='range' is-inline v-model='range' style="width: 100%"
                :min-page="minPage" :max-page="maxPage"
                :disabled-dates='disabledDates' :attributes="attrs"
                :input-debounce='0' @drag="dragValue = $event"
        >
            <div slot="day-popover" slot-scope="{day}">
                {{$options.filters.toCurrency(day.popovers[0].label)}}
            </div>
        </v-date-picker>
    </div>
</template>

<script>
  export default {
    name: 'Datepicker',

    components: {
      'v-date-picker': import(/* webpackPrefetch: true */ 'v-calendar/lib/components/date-picker.umd')
    },

    props: {
      times: Array,
      periods: Array,
      pickedPeriod: Object,
    },

    data() {
      return {
        dragValue: null,
        range: this.pickedPeriod,
      }
    },
    computed: {
      attrs() {
        let popovers = []
        let colors = ['indigo', 'purple', 'blue', 'teal', 'green', 'yellow', 'pink', 'orange', 'red', 'gray']
        for (let i in this.periods) {
          popovers.push({
            dates: {
              start: new Date(this.periods[i].date_start),
              end: new Date(this.periods[i].date_end),
            },
            dot: {
              color: colors[i % colors.length],
            },
            popover: {
              placement: 'top',
              label: this.periods[i].price,
            },
          })
        }
        return popovers
      },
      minPage() {
        return {
          month: this.minDate.getMonth() + 1,
          year: this.minDate.getFullYear()
        }
      },
      maxPage() {
        return {
          month: this.maxDate.getMonth() + 1,
          year: this.maxDate.getFullYear()
        }
      },
      minDate() {
        let date = new Date()
        if (this.times.length) {
          date = new Date(this.times[0]['date'])
        }
        return date
      },
      maxDate() {
        let date = new Date()
        if (this.times.length) {
          date = new Date(this.times[this.times.length - 1]['date'])
        }
        return date
      },
      disabledDates() {
        let arr = []
        if (this.times.length) {
          let first = new Date(this.times[0]['date'])
          let last = new Date(this.times[this.times.length - 1]['date'])

          arr.push({
            start: null,
            end: new Date(first.getTime() - 1000 * 60 * 60 * 24)
          })
          arr.push({
            start: new Date(last.getTime() + 1000 * 60 * 60 * 24),
            end: null
          })
          for (let i in this.times) {
            if (!this.times[i]['available']) {
              arr.push(new Date(this.times[i]['date']))
            }
          }
        }
        return arr
      },
      availableDates() {
        let arr = []
        if (this.times.length) {
          for (let i in this.times) {
            if (this.times[i]['available']) {
              arr.push(new Date(this.times[i]['date']))
            }
          }
        }
        return arr
      }
    },
    methods: {
      updatePickedPeriod(range) {
        this.$emit('update:pickedPeriod', range)
      },
    },
    watch: {
      range: {
        deep: true,
        handler: function (range) {
          if (range === null) {
            return
          }
          this.updatePickedPeriod(range)
        }
      },
      dragValue: {
        deep: true,
        handler: function (dragValue) {
          if (dragValue !== null) {
            this.updatePickedPeriod({ start: null, end: null })
          }
        }
      },
      pickedPeriod: {
        deep: true,
        handler: function (pickedPeriod) {
          this.range = pickedPeriod
        }
      }
    }
  }
</script>

<style scoped>

</style>

<style>
    .mx-datepicker-popup {
        z-index: 9999999;
    }
</style>